import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { LoadingSpinner, ScrollArea } from '@app/shared/ui/atoms/Common';
import {
  CardsHeaderSection,
  CardsSection,
  DescriptionSection,
} from '@app/shared/ui/organisms/DailyCardPreview';
import { TopBar } from '@app/shared/ui/molecules/DailyCardDescription';
import { usePreloadImages } from '@app/shared/hooks/usePreloadImages';
import { telegramVibrate } from '@app/shared/utils/common';
import { Page } from '@app/routes';
import type { CardIndex } from '@app/shared/types/pages/dailyCardPreview';
import { DAILY_CARD_PREVIEW_PRELOAD_IMAGES } from '@app/assets';

export default function DailyCardPreviewPage() {
  const [selectedCard, setSelectedCard] = useState<CardIndex>(0);
  const navigate = useNavigate();
  const isImagesLoading = usePreloadImages(DAILY_CARD_PREVIEW_PRELOAD_IMAGES);

  const handleCardClick = useCallback(
    (value: CardIndex) => {
      telegramVibrate();
      setSelectedCard(value);

      const timer = setTimeout(() => {
        void navigate(Page.DAILY_CARD_RESULT);
      }, 1000);

      return () => {
        clearTimeout(timer);
      };
    },
    [navigate]
  );

  const isSelectedCard = selectedCard !== 0;

  if (isImagesLoading) return <LoadingSpinner />;

  return (
    <ScrollArea className="gap-11 overflow-x-hidden pb-16">
      <TopBar />

      <DescriptionSection />

      <CardsHeaderSection isVisuallyHidden={isSelectedCard} />

      <CardsSection selectedCard={selectedCard} onCardClick={handleCardClick} />
    </ScrollArea>
  );
}
